var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{staticClass:"app-loader-overlay",attrs:{"show":_vm.show}},[_c('div',{staticClass:"app-loader-content"},[_c('img',{staticClass:"loader-image",attrs:{"src":require("@/assets/images/HUD.gif"),"alt":"Loading"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }